import Title from "../Title";
import Label from "../Label";
import Text from "../Text";
import Button from "../Button";
import Lines from "./Lines";
import Image from "../Image";

import "./index.css";

interface ExtendedCardDemoProps extends CardDemoProps {
  type: TemplateType;
}

const CardDemo = (props: ExtendedCardDemoProps) => {
  const {
    title,
    label,
    image,
    text,
    width = "350px",
    imageStyle = {},
    titleStyle = { marginTop: "32px" },
    cardCustomStyle = {},
    showLines = false,
  } = props;
  const { choose } = props;
  const { type } = props;

  return (
    <div className="base-card-demo" style={{ width }} onClick={choose.onClick}>
      <div className="base-card-demo-body" style={cardCustomStyle}>
        <div>
          {image && <Image style={{ ...styles.image }} styleImage={imageStyle} imagePath={image} />}
          {label && <Label type={type} text={label} />}
          <Title type={type} style={titleStyle} text={title} />
          <Text style={{ marginTop: "16px", marginBottom: "32px" }} type={type} text={text} />
          {showLines && <Lines />}
        </div>
        <div>
          <Button {...choose} />
        </div>
      </div>
    </div>
  );
};

const styles = {
  image: {},
};

export default CardDemo;
